import { StaticImage } from "gatsby-plugin-image"

import ProductList from "./product-list"

const Products = () => {
  return (
    <div
      sx={{
        mb: 0,
        mt: 0,
        backgroundColor: "#1A1C2B",
        overflow: "hidden",
      }}
      data-component-name="web-portal-plan-selection-products"
    >
      <StaticImage
        src="../images/product-set-complete.webp"
        alt=""
        placeholder="none"
        data-component-name="web-portal-plan-selection-products-image"
      />

      <ProductList />
    </div>
  )
}

export default Products
